document.addEventListener('DOMContentLoaded', () => {
  const container = document.getElementById('AjaxinateContainer')

  if (!container) return;

  const marketingBlock = document.getElementById('marketing-block')
  let marketingBlockPosition = 0

  if (marketingBlock) {
    marketingBlockPosition = parseInt(marketingBlock.getAttribute('data-position')) - 1; // 0 Index 
  }

  const inStockItems = []
  const oosItems = []
  const products = container.querySelectorAll('.grid__item[data-available]')

  products.forEach(product => {
    const isAvailable = product.getAttribute('data-available') === 'true'

    if (isAvailable) {
      inStockItems.push(product)
    } else {
      oosItems.push(product)
    }
  })

  if (marketingBlockPosition > 0) {
    inStockItems.splice(marketingBlockPosition, 0, marketingBlock)
  }

  // Clear Grid
  container.innerHTML = ''

  // Append in-stock items first
  inStockItems.forEach(item => {
    container.appendChild(item)
  })

  // Append oos items at the end
  oosItems.forEach(item => {
    container.appendChild(item)
  })

  if (container.classList.contains('loading-products')) {
    container.classList.remove('loading-products')
  }
})